import { render, staticRenderFns } from "./AppFormTip.vue?vue&type=template&id=8e4330a4&scoped=true&"
import script from "./AppFormTip.vue?vue&type=script&lang=js&"
export * from "./AppFormTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4330a4",
  null
  
)

export default component.exports